import React from "react";
const DispatchPage = (props) => {
    return (React.createElement("div", null));
};
export default DispatchPage;
